"use client";

import dynamic from "next/dynamic";
import type { SideBySideImageRevealBlock } from "@mw/shared/payload-types";

const BlockSideBySideImageReveal = dynamic(() =>
  import("./BlockSideBySideImageReveal").then(mod => mod.BlockSideBySideImageReveal),
);

export const BlockSideBySideImageRevealWrapper = (props: SideBySideImageRevealBlock) => {
  return <BlockSideBySideImageReveal {...props} />;
};
